import React from "react";
import { ForgetPasswordStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const ForgetPassword = ({ onSubmit }) => {
  const { t } = useTranslation(["common"]);
  const schema = yup.object().shape({
    test: yup.string().required("New password is required"),
  });

  const {
    control,
    handleSubmit,
    // formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <ForgetPasswordStyled>
      <div className="register_header">{t("Forgot password", { ns: "common" })}</div>
      <div className="register_title">{t("Enter email used for registration", { ns: "common" })}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              theme_standard2
              className="register_phone"
              label={t("Enter registration email", { ns: "common" })}
              placeholder="admin001@example.com"
              {...field}
              // placeholder={t('test')}
              // errors={errors.phone?.message}
            />
          )}
          name="test"
          defaultValue=""
        />
      </form>
      <div className="register_button">
        <Buttons.BgStandard label={t("Send password reset request", { ns: "common" })} />
      </div>
      <div className="back">
        <div className="back_text">{t("Want to login another way!", { ns: "common" })}</div>
        <button className="back_button">{t("Go back", { ns: "common" })}</button>
      </div>
    </ForgetPasswordStyled>
  );
};

ForgetPassword.propTypes = {};

export default ForgetPassword;
